import { render, staticRenderFns } from "./choiceMenu.vue?vue&type=template&id=97923edc&scoped=true"
import script from "./choiceMenu.vue?vue&type=script&lang=js"
export * from "./choiceMenu.vue?vue&type=script&lang=js"
import style0 from "./choiceMenu.vue?vue&type=style&index=0&id=97923edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97923edc",
  null
  
)

export default component.exports